export var flaineColors = {
  "--GW-BACKGROUND-COLOR-BODY": "#f0f1f5"
};